<template>
  <q-page padding>
    <div class="row col-12 justify-between">
      <div>
        <p class="text-h6 text-weight-bold text-brand-1 texto-titulo">
          Nova Necessidade de Compra
        </p>
      </div>
      <div>
        <router-link :to="{ name: 'compras-necessidades' }">
          <div
            style="cursor: pointer; color: #8a8a8a"
            class="row items-center text-weight-bold q-mr-md container-link-voltar"
          >
            <q-icon class="q-mr-sm icon-voltar" name="west" />
            <span class="texto-titulo">Voltar</span>
          </div>
        </router-link>
      </div>
    </div>
    <div class="q-ml-md">
      <div class="row col-12 text-brand-1 text-weight-bold q-gutter-sm q-mt-md">
        <div class="col-md">
          <div class="q-ml-sm">Urgência</div>
          <q-select
            :options="options"
            label="Selecione uma Urgencia"
            dense
            outlined
            behavior="menu"
            v-model="urgencia"
            :rules="[(val) => val || 'Campo Obrigatório']"
          />
        </div>

        <div class="col-md">
          <div class="q-ml-sm">Solicitante</div>
          <SelectSolicitante v-model="solicitante" />
        </div>
        <div class="col-md">
          <div class="q-ml-sm">Centro de Custo</div>
          <SelectCentroCustos v-model="centro" />
        </div>
        <div class="col-md">
          <div class="q-ml-sm">Responsável pela Compra</div>
          <SelectSolicitanteCompra v-model="responsavel" />
        </div>
      </div>
      <div class="row col-12 q-mt-md">
        <div
          style="font-size: 16px"
          class="q-mb-sm row col-12 text-brand-1 text-weight-medium"
        >
          <span>Selecione um grupo de produto que desejar.</span>
        </div>
        <div class="row col-12 text-weight-bold q-gutter-sm">
          <div class="col-3 text-brand-1">
            <div class="q-ml-sm">Grupo de Produtos</div>
            <SelectGrupos v-model="grupos" :disable="todos" />
          </div>
          <div>
            <p></p>
            <q-toggle
              class="q-mt-xs text-brand-1"
              left-label
              label="Selecionar Todos"
              v-model="todos"
              color="brand-1"
              @click="grupos = ''"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="q-mt-lg">
      <div
        class="row col-12 q-ml-lg justify-between items-center q-my-md text-brand-1 text-weight-medium"
        style="font-size: 16px"
      >
        <span>
          Selecione os produtos que deseja incluir na necessidade de compra
        </span>
        <q-input
          rounded
          outlined
          dense
          debounce="300"
          class="col-md-4"
          v-model="filter"
          placeholder="Pesquisar Produtos"
        >
          <template v-slot:append>
            <q-icon name="search" />
          </template>
        </q-input>
      </div>
      <q-table
        flat
        :rows="rows"
        dense
        :columns="columns"
        table-header-style="background-color: #d9effc"
        :loading="disable"
        color="primary"
        title-class="text-brand-5 text-weight-bold"
        hide-pagination
        class="tabela-tamanho-fixo"
        v-model:pagination="pagination"
        :rows-per-page-options="[0]"
      >
        <template #body-cell-selecionar="props">
          <q-td>
            <q-checkbox
              :disable="responsavel == ''"
              v-model="selecionados"
              :val="props.row"
            />
          </q-td>
        </template>
      </q-table>
      <div class="row justify-start q-mt-md" v-if="rows.length > 0">
        <q-pagination
          :disable="disable"
          v-model="pagination.page"
          color="brand-5"
          active-color="secondary"
          active-text-color="white"
          :max="pagesNumber"
          :max-pages="5"
          :boundary-numbers="false"
          :direction-links="true"
          size="sm"
        />
      </div>
    </div>

    <div v-if="produtosSelecionados.length != 0" class="q-mt-lg">
      <div
        class="row col-12 q-ml-lg justify-between items-center q-my-md text-brand-1 text-weight-medium"
      >
        <span style="font-size: 16px"> Produtos Selecionados </span>
        <q-input
          rounded
          outlined
          dense
          debounce="300"
          v-model="filtrar"
          class="col-md-4"
          placeholder="Pesquisar"
        >
          <template v-slot:append>
            <q-icon name="search" />
          </template>
        </q-input>
      </div>
      <q-table
        flat
        :rows="produtosSelecionados"
        table-header-style="background-color: #d9effc"
        dense
        :columns="columns2"
        class="tabela-tamanho-fixo"
        title-class="text-brand-5 text-weight-bold"
        :loading="disable"
        :filter="filtrar"
        hide-pagination
        :rows-per-page-options="[0]"
      >
        <template #body-cell-delete="props">
          <q-td>
            <q-btn
              round
              icon="sym_o_delete"
              color="red"
              flat
              @click="remove(props.rowIndex)"
            />
          </q-td>
        </template>

        <template #body-cell-tipo="props">
          <q-td>
            <span v-if="props.row">NECESSIDADE</span>
          </q-td>
        </template>
        <template #body-cell-amount="props">
          <q-td>
            <q-input
              dense
              outlined
              v-model="props.row.amount"
              onkeypress="return event.charCode >= 48 && event.charCode <= 57"
            />
          </q-td>
        </template>
      </q-table>
    </div>

    <div class="row col-12 q-mt-xl q-ml-md">
      <span
        class="row col-12 text-brand-1 text-weight-bold"
        style="font-size: 16px"
        >Digite um histórico para a requisição se necessário for:</span
      >
      <q-input
        class="q-mt-sm col-md-6 col-sm-12"
        dense
        outlined
        type="textarea"
        v-model="observacao"
      />

      <div class="row col-12 q-mt-md">
        <q-btn
          class="q-mr-sm"
          label="Criar Necessidade e Requisição"
          icon="add"
          style="color: white; background-color: #21324a"
          no-caps
          :disable="produtosSelecionados.length == 0 || urgencia == ''"
          @click="abrirDialogAmbos"
        />
        <q-btn
          @click="abrirDialogNecessidade"
          class="q-mr-sm"
          no-caps
          icon="done"
          label="Criar Somente a Necessidade"
          style="color: white; background-color: #304f78"
          :disable="produtosSelecionados.length == 0 || urgencia == ''"
        />
      </div>
      <dialog-info-design
        class="row col-12"
        mensagem="Detalhes Necessidade Compra"
        sub-mensagem="Preencha os dados abaixo para complementar as informações e auxiliar no processo de compras."
        :showConteudo="true"
        :showCancelar="true"
        :exibir="finalDialog"
        :desabilitarConfirme="
          finalDialogForm.data_aplicacao == '' ||
          finalDialogForm.justificativa_contratacao == ''
        "
        @resultado="resultadoDialog"
      >
        <div>
          <div class="q-ml-sm texto-titulo-input">Data de Aplicação *</div>
          <q-input
            class="input-new-design"
            dense
            outlined
            v-model="finalDialogForm.data_aplicacao"
            mask="##/##/####"
          >
            <template v-slot:append>
              <q-icon name="event" class="cursor-pointer">
                <q-popup-proxy
                  cover
                  transition-show="scale"
                  transition-hide="scale"
                >
                  <q-date
                    :locale="myLocale"
                    mask="DD/MM/YYYY"
                    v-model="finalDialogForm.data_aplicacao"
                  >
                    <div class="row items-center justify-end">
                      <q-btn
                        v-close-popup
                        label="Fechar"
                        color="primary"
                        flat
                      />
                    </div>
                  </q-date>
                </q-popup-proxy>
              </q-icon>
            </template>
          </q-input>
        </div>
        <div>
          <div class="q-ml-sm texto-titulo-input">
            Justificativa Contratação *
          </div>
          <q-input
            v-model="finalDialogForm.justificativa_contratacao"
            dense
            outlined
            type="textarea"
            class="input input-new-design"
          />
        </div>
        <div>
          <div class="q-ml-sm texto-titulo-input">Detalhamento Técnico</div>
          <q-input
            v-model="finalDialogForm.detalhamento_tecnico"
            dense
            outlined
            type="textarea"
            class="input input-new-design"
          />
        </div>
        <div>
          <div class="q-ml-sm texto-titulo-input">
            Responsabilidades Fornecedores
          </div>
          <q-input
            v-model="finalDialogForm.responsabilidades_fornecedores"
            dense
            outlined
            type="textarea"
            class="input input-new-design"
          />
        </div>
        <div>
          <div class="q-ml-sm texto-titulo-input">
            Responsabilidades Contratante
          </div>
          <q-input
            v-model="finalDialogForm.responsabilidades_contratante"
            dense
            outlined
            type="textarea"
            class="input input-new-design"
          />
        </div>
        <div>
          <div class="q-ml-sm texto-titulo-input">Possíveis Fornecedores</div>
          <q-input
            v-model="finalDialogForm.possiveis_fornecedores"
            dense
            outlined
            type="textarea"
            class="input input-new-design"
          />
        </div>
      </dialog-info-design>
    </div>
  </q-page>
</template>

<script>
const columns = [
  {
    name: "selecionar",
    label: "Selecionar",
    field: "selecionar",
    align: "left",
  },

  {
    name: "produto_codigo",
    label: "Código",
    field: "produto_codigo",
    align: "left",
  },
  {
    name: "produto_descricao",
    label: "Descrição",
    field: "produto_descricao",
    align: "left",
  },
  {
    name: "categoria_codigo",
    label: "Categoria",
    field: "categoria_codigo",
    align: "left",
  },
  {
    name: "endereco",
    label: "Endereço",
    field: "endereco",
    align: "left",
  },
  {
    name: "produto_preco",
    label: "Preço",
    field: (row) =>
      row.produto_preco
        ? `R$ ${Number(row.produto_preco).toFixed(2)} `
        : "Sem Preço",
    align: "left",
  },

  {
    name: "unidade_medida",
    label: "Unid. Medida",
    field: "unidade_medida",
    align: "left",
  },
  {
    name: "quantidade",
    label: "Estoque",
    field: "quantidade",
    align: "left",
  },
  {
    name: "quantidade_reposicao",
    label: "Estoque Min",
    field: "quantidade_reposicao",
    align: "left",
  },
];

const columns2 = [
  {
    name: "delete",
    label: "Remover",
    field: "delete",
    align: "left",
  },
  {
    name: "tipo",
    label: "Tipo",
    field: "tipo",
    align: "left",
    style: "color: #707070; font-weight: bold",
  },

  {
    name: "produto_codigo",
    label: "Código",
    field: "produto_codigo",
    align: "left",
    style: "color: #707070; font-weight: bold",
  },
  {
    name: "produto_descricao",
    label: "Descrição",
    field: "produto_descricao",
    align: "left",
    style: "color: #707070; font-weight: bold",
  },
  {
    name: "categoria_codigo",
    label: "Categoria",
    field: "categoria_codigo",
    align: "left",
    style: "color: #707070; font-weight: bold",
  },
  {
    name: "endereco",
    label: "Endereço",
    field: "endereco",
    align: "left",
    style: "color: #707070; font-weight: bold",
  },
  {
    name: "produto_preco",
    label: "Preço",
    field: (row) =>
      row.produto_preco
        ? `R$ ${Number(row.produto_preco).toFixed(2)} `
        : "Sem Preço",
    align: "left",
    style: "color: #707070; font-weight: bold",
  },

  {
    name: "unidade_medida",
    label: "Unid. Medida",
    field: "unidade_medida",
    align: "left",
    style: "color: #707070; font-weight: bold",
  },
  {
    name: "quantidade",
    label: "Estoque",
    field: "quantidade",
    align: "left",
    style: "color: #707070; font-weight: bold",
  },
  {
    name: "quantidade_reposicao",
    label: "Estoque Min",
    field: "quantidade_reposicao",
    align: "left",
    style: "color: #707070; font-weight: bold",
  },
  {
    name: "amount",
    label: "Quantidade",
    field: "amount",
    align: "left",
    style: "color: #707070; font-weight: bold",
  },
];

import { watch, computed } from "vue";
import { ref } from "@vue/reactivity";
import { useRouter } from "vue-router";
// import CentroCustoTable from "../components/CentroCustoTable.vue";
// import SolicitanteTable from "../components/SolicitanteTable.vue";
import SelectSolicitante from "../components/SelectSolicitante.vue";
// import GruposTable from "../components/GruposTable.vue";
import { useStore } from "vuex";
import { useQuasar } from "quasar";
// import RequisitanteTable from "../components/RequisitanteTable.vue";
import SelectCentroCustos from "../components/SelectCentroCustos.vue";
import SelectSolicitanteCompra from "../components/SelectSolicitanteCompra.vue";
import SelectGrupos from "../components/SelectGrupos.vue";
import DialogInfoDesign from "../../../../components/DialogInfoDesign.vue";

export default {
  components: {
    // CentroCustoTable,
    SelectCentroCustos,
    // SolicitanteTable,
    SelectGrupos,
    SelectSolicitante,
    // GruposTable,
    SelectSolicitanteCompra,
    // RequisitanteTable,
    DialogInfoDesign,
  },
  setup() {
    const quasar = useQuasar();
    const router = useRouter();
    const store = useStore();
    const disable = ref(false);
    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 6,
      rowsNumber: 15,
    });
    const selected = ref([]);
    const urgencia = ref("");
    const centro = ref("");
    const solicitante = ref();
    const grupos = ref("");
    const responsavel = ref("");
    const rows = ref([]);
    const filter = ref("");
    const selecionados = ref([]);
    const produtosSelecionados = ref([]);
    const observacao = ref("");
    const todos = ref(false);
    const filtrar = ref("");
    const finalDialog = ref(false);
    const finalDialogForm = ref({
      data_aplicacao: "",
      justificativa_contratacao: "",
      detalhamento_tecnico: "",
      responsabilidades_fornecedores: "",
      responsabilidades_contratante: "",
      possiveis_fornecedores: "",
    });
    const acaoSelecionada = ref("");
    const myLocale = {
      days: "Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado".split(
        "_"
      ),
      daysShort: "Dom_Seg_Ter_Qua_Qui_Sex_Sáb".split("_"),
      months:
        "Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro".split(
          "_"
        ),
      monthsShort: "Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez".split("_"),
      firstDayOfWeek: 1,
    };
    const abrirDialogAmbos = () => {
      acaoSelecionada.value = "ambos";
      setTimeout(() => {
        finalDialog.value = true;
      }, 0);
    };
    const abrirDialogNecessidade = () => {
      acaoSelecionada.value = "necessidade";
      setTimeout(() => {
        finalDialog.value = true;
      }, 0);
    };

    const resultadoDialog = async (resultado) => {
      finalDialog.value = false;
      if (resultado) {
        if (acaoSelecionada.value === "ambos") {
          await criarNecessidadeRequisicao();
        } else {
          await criarNecessidade();
        }
      }
      acaoSelecionada.value = "";
    };

    const receberSolicitante = async (value) => {
      solicitante.value = value;
    };

    const receberCentro = async (value) => {
      centro.value = value;
    };

    const receberGrupo = async (value) => {
      grupos.value = value;
    };

    const receberRequisitante = async (value) => {
      responsavel.value = value;
    };

    const getProdutos = async (page = 1, rowsPerPage = 15) => {
      disable.value = true;
      try {
        const response = await store.dispatch("compras/getProdutos", {
          vendor_id: store.state.org.unidadeData.id,
          search: filter.value,
          page,
          per_page: rowsPerPage,
          grupo_id: grupos.value?.id,
        });

        rows.value = response.data.data;
        pagination.value.rowsNumber = response.data.total;
        pagination.value.page = response.data.current_page;
        disable.value = false;
      } catch (error) {
        disable.value = false;
        quasar.notify({
          message: "Erro a o procurar dados",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    watch(
      () => grupos.value,
      () => {
        getProdutos();
      }
    );

    watch(
      () => selecionados.value,
      () => {
        produtosSelecionados.value = selecionados.value;
      }
    );

    const criarNecessidade = async () => {
      let produtos = [];

      produtosSelecionados.value.forEach((e) => {
        produtos.push({
          codigo: e.produto_codigo,
          id: e.produto_id,
          responsavel_id: responsavel.value?.id,
          quantidade: e.amount,
        });
      });

      try {
        const payload = {
          vendor_id: store.state.org.unidadeData.id,
          cost_center_id: centro.value?.id,
          solicitante_id: solicitante.value?.id,
          tag_id: urgencia.value?.value,
          produtos: produtos,
          observacao: observacao.value,
          data_aplicacao: finalDialogForm.value.data_aplicacao
            ? finalDialogForm.value.data_aplicacao
                .split("/")
                .reverse()
                .join("-")
            : undefined,
          detalhamento_tecnico:
            finalDialogForm.value.detalhamento_tecnico || undefined,
          responsabilidades_fornecedores:
            finalDialogForm.value.responsabilidades_fornecedores || undefined,
          responsabilidades_contratante:
            finalDialogForm.value.responsabilidades_contratante || undefined,
          possiveis_fornecedores:
            finalDialogForm.value.possiveis_fornecedores || undefined,
          justificativa_contratacao:
            finalDialogForm.value.justificativa_contratacao || undefined,
        };

        const response = await store.dispatch(
          "compras/criarNecessidade",
          payload
        );

        quasar.notify({
          message: "Necessidade criada com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });

        router.push({
          name: "compras-detalhe",
          params: { id: response.data.result.uuid },
        });
      } catch (error) {
        quasar.notify({
          message: "Erro ao criar a necessidade",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const criarNecessidadeRequisicao = async () => {
      let voucher = [];

      produtosSelecionados.value.forEach((e) => {
        voucher.push({
          id: e.produto_id,
          amount: e.amount,
        });
      });

      try {
        await store.dispatch("compras/criarNecessidadeRequisicao", {
          vendor_id: store.state.org.unidadeData.id,
          cost_center_id: centro.value?.id,
          plantiff_id: solicitante.value?.id,
          products: voucher,
        });

        let produtos = [];
        produtosSelecionados.value.forEach((e) => {
          produtos.push({
            codigo: e.produto_codigo,
            id: e.produto_id,
            responsavel_id: responsavel.value.id,
            quantidade: e.amount,
          });
        });

        const payloadNecessidade = {
          vendor_id: store.state.org.unidadeData.id,
          cost_center_id: centro.value?.id,
          solicitante_id: solicitante.value?.id,
          tag_id: urgencia.value?.value,
          produtos: produtos,
          observacao: observacao.value,
          data_aplicacao: finalDialogForm.value.data_aplicacao
            ? finalDialogForm.value.data_aplicacao
                .split("/")
                .reverse()
                .join("-")
            : undefined,
          detalhamento_tecnico:
            finalDialogForm.value.detalhamento_tecnico || undefined,
          responsabilidades_fornecedores:
            finalDialogForm.value.responsabilidades_fornecedores || undefined,
          responsabilidades_contratante:
            finalDialogForm.value.responsabilidades_contratante || undefined,
          possiveis_fornecedores:
            finalDialogForm.value.possiveis_fornecedores || undefined,
          justificativa_contratacao:
            finalDialogForm.value.justificativa_contratacao || undefined,
        };

        const response = await store.dispatch(
          "compras/criarNecessidade",
          payloadNecessidade
        );

        quasar.notify({
          message: "Necessidade e requisição criadas com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });

        router.push({
          name: "compras-detalhe",
          params: { id: response.data.result.uuid },
        });
      } catch (error) {
        quasar.notify({
          message: "Erro ao criar a necessidade e requisição",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const remove = async (index) => {
      produtosSelecionados.value.splice(index, 1);
    };

    watch(
      () => todos.value,
      () => {
        if (!todos.value) {
          rows.value = [];
          selecionados.value = [];
          return;
        }
        getProdutos();
      }
    );

    watch(
      () => pagination.value.page,
      () => {
        getProdutos(pagination.value.page, pagination.value.rowsPerPage);
      }
    );

    watch(
      () => filter.value,
      () => {
        getProdutos(pagination.value.page, pagination.value.rowsPerPage);
      }
    );

    return {
      options: [
        {
          label: "Normal",
          value: 1,
        },
        {
          label: "Urgente",
          value: 2,
        },
        {
          label: "Máquina Parada",
          value: 3,
        },
      ],
      urgencia,
      receberCentro,
      centro,
      receberSolicitante,
      solicitante,
      receberGrupo,
      grupos,
      getProdutos,
      rows,
      columns,
      filter,
      selected,
      disable,
      pagination,
      selecionados,
      receberRequisitante,
      responsavel,
      pagesNumber: computed(() =>
        Math.ceil(pagination.value.rowsNumber / pagination.value.rowsPerPage)
      ),
      produtosSelecionados,
      columns2,
      observacao,
      criarNecessidade,
      remove,
      criarNecessidadeRequisicao,
      todos,
      filtrar,
      finalDialog,
      finalDialogForm,
      myLocale,
      resultadoDialog,
      abrirDialogAmbos,
      abrirDialogNecessidade,
    };
  },
};
</script>

<style scoped>
a {
  text-decoration: none;
}
tbody tr td {
  white-space: pre-wrap;
}
.container-link-voltar {
  margin-right: 10px;
}
.icon-voltar {
  font-size: 25px;
}
.texto-titulo {
  font-size: 20px;
}
@media (max-width: 600px) {
  .texto-titulo {
    font-size: 16px;
  }
  .container-link-voltar {
    margin: 5px 0px 0px 0px;
  }
  .icon-voltar {
    font-size: 20px;
    margin-right: 1px;
  }
}
</style>
